<template>
  <div class="language-switcher">
    <button 
      @click="switchLanguage('en')" 
      :class="{ active: currentLocale === 'en' }"
      class="lang-btn"
    >
      EN
    </button>
    <span class="separator">|</span>
    <button 
      @click="switchLanguage('ru')" 
      :class="{ active: currentLocale === 'ru' }"
      class="lang-btn"
    >
      RU
    </button>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n()
    
    const switchLanguage = (lang) => {
      locale.value = lang
      localStorage.setItem('preferred-language', lang)
    }
    
    // Set initial language from localStorage
    const savedLang = localStorage.getItem('preferred-language')
    if (savedLang) {
      locale.value = savedLang
    }
    
    return {
      currentLocale: locale,
      switchLanguage
    }
  }
}
</script>

<style scoped>
.language-switcher {
  padding-top: 0.3rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.lang-btn {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.lang-btn:hover {
  color: #666;
  background: #ccc;
}

.lang-btn.active {
  /* color: #667eea; */
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}

.separator {
  color: #666;
  font-weight: 300;
}
</style>